import { Link } from 'react-router-dom';
import type { Article } from '@/types';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'featured';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  return (
    <article className="group bg-background-100 rounded-lg overflow-hidden hover:bg-background-200/70 transition-colors">
      <div className="relative w-full h-48 md:h-56 overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 黑料吃瓜独家爆料`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
          {article.category}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base md:text-lg font-semibold text-foreground-950 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
          <Link to={`/article/${article.slug}`}>{article.title}</Link>
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-600 mb-3 flex-wrap">
          <span>{article.publishedAt}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-500" />
          <span>{article.views.toLocaleString()} 阅读</span>
        </div>
        <p className="text-sm text-foreground-700 line-clamp-2 mb-4">{article.excerpt}</p>
        <Link
          to={`/article/${article.slug}`}
          className={`inline-flex items-center gap-1 px-4 py-2 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
            variant === 'featured'
              ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
              : 'border border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50'
          }`}
        >
          阅读全文
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </article>
  );
}